import type { SocialLink } from '@/types';
import { socialLinks } from '@/data/socialLinks';
import { SocialIcon } from '@/components/common/SocialIcon';
import styles from './SocialLinks.module.css';

interface SocialLinksProps {
  links?: SocialLink[];
  className?: string;
}

export function SocialLinks({ links = socialLinks, className }: SocialLinksProps) {
  return (
    <ul className={`${styles.list} ${className ?? ''}`.trim()}>
      {links.map((link) => (
        <li key={link.id}>
          <a
            href={link.href}
            className={styles.link}
            target={link.external ? '_blank' : undefined}
            rel={link.external ? 'noopener noreferrer' : undefined}
            aria-label={link.label}
          >
            <SocialIcon platform={link.platform} />
            <span>{link.label}</span>
          </a>
        </li>
      ))}
    </ul>
  );
}
